import {Component, OnDestroy} from '@angular/core';
import {QuestionComponent} from '../question/question.component';
import {TRANSLATION_EDITOR_SCOPE} from '../../../constants';
import {KEYS} from '../../../translation-keys';
import {Translatable} from '@ngmedax/translation';


@Component({
  selector: 'app-qa-page-break',
  templateUrl: './page-break.component.html',
  styleUrls: [
    '../question/question.component.css',
    '../../shared/reusable.css'
  ]
})
@Translatable({scope: TRANSLATION_EDITOR_SCOPE, keys: KEYS})
export class PageBreakComponent extends QuestionComponent implements OnDestroy {
  private titleChangeTimeout: any = null;

  /**
   * Called when the page title changes.
   * Debounces the update to avoid triggering on every keystroke.
   */
  public onTitleChange(): void {
    if (this.titleChangeTimeout) {
      clearTimeout(this.titleChangeTimeout);
    }

    this.titleChangeTimeout = setTimeout(() => {
      this.state.updateElement(this.question, this.position);
      this.titleChangeTimeout = null;
    }, 300);
  }

  /**
   * Cleanup timeout on destroy.
   */
  public ngOnDestroy(): void {
    super.ngOnDestroy();

    if (this.titleChangeTimeout) {
      clearTimeout(this.titleChangeTimeout);
    }
  }
}
